<template>
  <div class="flowTop">
    <div class="flex no">
      <div class="">
        <span class="label">审批编号：</span>
        <span>{{ dataInfo.approval_no }}</span>
      </div>
      <div class="flex">
        <prints :dataInfo="dataInfo"></prints>
        <share :dataInfo="dataInfo"></share>
      </div>
    </div>

    <div class="flex no" style="border: none; margin: 10px 0 20px">
      <div>
        <span class="title">{{ dataInfo.approval_name }}</span>
        <span :class="`status${dataInfo.status} status`">
          {{
            toStr(
              {
                1: "审批中",
                2: "已撤销",
                3: "审批通过",
                4: "审批拒绝",
              },
              dataInfo.status
            )
          }}</span
        >
      </div>
      <div class="time">
        <img
          class="ta"
          v-if="dataInfo.creator.picture"
          :src="dataInfo.creator.picture"
          fit="cover"
        />
        <div class="tan" v-else>
          {{ dataInfo.creator.name ? dataInfo.creator.name.slice(-1) : "" }}
        </div>
        <span class="tat">{{ dataInfo.creator.name }}</span>
        {{ dataInfo.create_time }} 发起
      </div>
    </div>
  </div>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import prints from "@/components/print.vue";
import share from "@/components/share.vue";
export default {
  name: "flowTop",
  mixins: [mixinTable],
  props: {
    dataInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  components: {
    prints,
    share,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  justify-content: space-between;
}
.label {
  color: #999;
}
.no {
  padding: 0 20px;
  height: 50px;
  line-height: 50px;
  border-bottom: solid 1px #eee;
  font-weight: bold;
  font-size: 14px;
}
.ta {
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 50%;
}
.flowTop {
  .title {
    margin-right: 20px;
    font-size: 16px;
    font-weight: bold;
  }
  .time {
    display: flex;
    align-items: center;
    color: #999;
  }
}
</style>